import { useEffect } from "react";

// IntersectionObserver-driven .fade-up reveal helper.
// Adds .in-view to any element with .fade-up when it enters the viewport.
export default function ScrollReveal() {
    useEffect(() => {
        const els = document.querySelectorAll(".fade-up");
        if (!("IntersectionObserver" in window)) {
            els.forEach((el) => el.classList.add("in-view"));
            return;
        }
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in-view");
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
        );
        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);
    return null;
}
